import React, { useState, useRef, useEffect } from 'react';
import { ParameterDef, ProjectParameters } from '../../types/ProjectParameters';

interface AddParamButtonProps {
  definitions: ParameterDef[];
  visibleKeys: Set<keyof ProjectParameters>;
  onAdd: (key: keyof ProjectParameters) => void;
}

const AddParamButton: React.FC<AddParamButtonProps> = ({ definitions, visibleKeys, onAdd }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const available = definitions.filter(d => !visibleKeys.has(d.key));

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [isOpen]);

  if (available.length === 0) return null;

  return (
    <div ref={ref} className="relative inline-block">
      <button
        onClick={() => setIsOpen(o => !o)}
        className="inline-flex items-center gap-1 px-2 py-0.5 text-xs text-gray-400 hover:text-violet-600 hover:bg-violet-50 border border-dashed border-gray-300 hover:border-violet-300 rounded-full transition-colors"
      >
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
        </svg>
        Ajouter
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-200 rounded-lg shadow-lg py-1 min-w-[200px]">
          {available.map(def => (
            <button
              key={def.key}
              onClick={() => { onAdd(def.key); setIsOpen(false); }}
              className="w-full text-left px-3 py-1.5 text-xs text-gray-700 hover:bg-violet-50 hover:text-violet-700"
            >
              {def.fullLabel}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AddParamButton;
